// extracted by mini-css-extract-plugin
export var active = "_4g-7";
export var container = "_4g-0";
export var evenWidth = "_4g-4";
export var large = "_4g-5";
export var outlet = "_4g-8";
export var slide = "_4g-2";
export var small = "_4g-6";
export var tab = "_4g-3";
export var tabs = "_4g-1";